import { useEffect, useState } from "react";
import { api } from "@/lib/api";

/**
 * Fetches a protected file via /api/files/{path} and returns a blob URL.
 * Blob URL is safe to use in <img src>, and renders correctly under window.print().
 */
export function useAuthImage(storagePath) {
  const [url, setUrl] = useState(null);
  const [error, setError] = useState(null);

  useEffect(() => {
    if (!storagePath) { setUrl(null); return; }
    let cancelled = false;
    let objectUrl = null;
    (async () => {
      try {
        const res = await api.get(`/files/${storagePath}`, { responseType: "blob" });
        if (cancelled) return;
        objectUrl = URL.createObjectURL(res.data);
        setUrl(objectUrl);
      } catch (e) {
        if (!cancelled) setError(e);
      }
    })();
    return () => {
      cancelled = true;
      if (objectUrl) URL.revokeObjectURL(objectUrl);
    };
  }, [storagePath]);

  return { url, error };
}

export default function AuthImage({ path, className, alt = "", testid, "data-testid": testId }) {
  const { url } = useAuthImage(path);
  const tid = testid || testId;
  if (!url) {
    return <div className={`${className || ""} bg-secondary animate-pulse`} data-testid={tid} />;
  }
  return <img src={url} alt={alt} className={className} data-testid={tid} />;
}
